import { usePaymentMethodLabel } from "@/lib/payment-method-label";

/**
 * Muestra el nombre legible de un método de pago a partir del valor guardado
 * en `reservations.balance_payment_method` (UUID o "pagos_divididos").
 */
export function PaymentMethodLabel({ value }: { value?: string | null }) {
  const label = usePaymentMethodLabel(value);
  return <span className="font-medium text-foreground">{label}</span>;
}
